import { Component, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CheckboxFieldComponent } from '../../../atoms/forms/checkbox-field/checkbox-field.component';
import { ErrorFieldComponent } from '../../../atoms/forms/error-field/error-field.component';
import { ErrorTypeLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-checkbox-field-with-error',
  imports: [CommonModule, CheckboxFieldComponent, ErrorFieldComponent],
  templateUrl: './checkbox-field-with-error.component.html',
  styleUrl: './checkbox-field-with-error.component.scss',
  standalone: true
})
export class CheckboxFieldWithErrorComponent {
  /** The FormControl that manages the checkbox value and validation state */
  ctrl = input.required<AbstractControl>();

  /** The label text displayed next to the checkbox */
  label = input<string>();

  /** Whether the checkbox is required and should display a red asterisk indicator */
  required = input<boolean>(false);

  /** Custom error messages for different validation types */
  errorMessages = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
